import {LonerStatics} from "../../LonerStatics";
import {Loner} from "../../Loner";
import {GlowFrame} from "../../utils/GlowFrame";
import {gsap} from "gsap";

export class LonerSymOverlayAnimationsView extends PIXI.Container {


    private _symbolAnimation: GlowFrame[][] = [];
    //big wild 3X3
    private _stackSymAnimation_3X3_full: GlowFrame;
    private _stackSymAnimation_3X3_top: GlowFrame;
    private _stackSymAnimation_3X3_half_top: GlowFrame;
    private _stackSymAnimation_3X3_bottom: GlowFrame;
    private _stackSymAnimation_3X3_half_bottom: GlowFrame;

    //big wild 2X2
    private _stackSymAnimation_2X2_full_top_reel_1: GlowFrame;
    private _stackSymAnimation_2X2_full_bottom_reel_1: GlowFrame;
    private _stackSymAnimation_2X2_top_half_reel_1: GlowFrame;
    private _stackSymAnimation_2X2_bottom_half_reel_1: GlowFrame;

    private _stackSymAnimation_2X2_full_top_reel_2: GlowFrame;
    private _stackSymAnimation_2X2_full_bottom_reel_2: GlowFrame;
    private _stackSymAnimation_2X2_top_half_reel_2: GlowFrame;
    private _stackSymAnimation_2X2_bottom_half_reel_2: GlowFrame;

    constructor() {
        super();
        this.init();
    }

    public playPreWinHighlightAnim(reelId: number, symId: number, symName: string): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        let symAnimToPlay: GlowFrame = this._symbolAnimation[reelId][symId];
        if ((reelId === 1 || reelId === 2 || reelId === 3) && Loner.model.bigWildSize >= 2) {
            const bigWildSize: number = Loner.model.bigWildSize;
            const bigWildData = Loner.model.bigWildWinAnimationHighlightData;
            if (bigWildSize === 3) {
                if (reelId === 1) {
                    if (symId === 0) {
                        if (bigWildData.bigWinPresentOnSymbols?.includes(0) && bigWildData.bigWinPresentOnSymbols?.includes(1) && bigWildData.bigWinPresentOnSymbols?.includes(2)) {
                            symAnimToPlay = this._stackSymAnimation_3X3_full;
                        } else if (bigWildData.bigWinPresentOnSymbols?.includes(0) && bigWildData.bigWinPresentOnSymbols?.includes(1) && !bigWildData.bigWinPresentOnSymbols?.includes(2)) {
                            symAnimToPlay = this._stackSymAnimation_3X3_half_top;
                        } else if (bigWildData.bigWinPresentOnSymbols?.includes(0) && !bigWildData.bigWinPresentOnSymbols?.includes(1) && !bigWildData.bigWinPresentOnSymbols?.includes(2)) {
                            symAnimToPlay = this._stackSymAnimation_3X3_top;
                        }
                    } else if (symId === 1) {
                        if (!bigWildData.bigWinPresentOnSymbols?.includes(0) && bigWildData.bigWinPresentOnSymbols?.includes(1) && bigWildData.bigWinPresentOnSymbols?.includes(2)) {
                            symAnimToPlay = this._stackSymAnimation_3X3_half_bottom;
                        } else {
                            if ((bigWildData.bigWinPresentOnSymbols?.includes(0) && bigWildData.bigWinPresentOnSymbols?.includes(1) && bigWildData.bigWinPresentOnSymbols?.includes(2))
                                || (bigWildData.bigWinPresentOnSymbols?.includes(0) && bigWildData.bigWinPresentOnSymbols?.includes(1) && !bigWildData.bigWinPresentOnSymbols?.includes(2))) {
                                return tl;
                            }
                        }
                    } else if (symId === 2) {
                        if (!bigWildData.bigWinPresentOnSymbols?.includes(0) && !bigWildData.bigWinPresentOnSymbols?.includes(1) && bigWildData.bigWinPresentOnSymbols?.includes(2)) {
                            symAnimToPlay = this._stackSymAnimation_3X3_bottom;
                        } else {
                            if ((!bigWildData.bigWinPresentOnSymbols?.includes(0) && bigWildData.bigWinPresentOnSymbols?.includes(1) && bigWildData.bigWinPresentOnSymbols?.includes(2))
                                || (bigWildData.bigWinPresentOnSymbols?.includes(0) && bigWildData.bigWinPresentOnSymbols?.includes(1) && bigWildData.bigWinPresentOnSymbols?.includes(2))) {
                                return tl;
                            }
                        }
                    }
                } else {
                    if (bigWildData.bigWinPresentOnReels?.includes(reelId) && bigWildData.bigWinPresentOnSymbols?.includes(symId)) {
                        return tl;
                    }
                }
            } else if (bigWildSize === 2) {
                if (reelId === 1) {
                    const winOnReel1And2: boolean | undefined = bigWildData.bigWinPresentOnReels?.includes(1) && bigWildData.bigWinPresentOnReels?.includes(2);
                    if (symId === 0 && winOnReel1And2) {
                        if (bigWildData.bigWinPresentOnSymbols?.includes(0) && bigWildData.bigWinPresentOnSymbols?.includes(1) && !bigWildData.bigWinPresentOnSymbols?.includes(2)) {
                            symAnimToPlay = this._stackSymAnimation_2X2_full_top_reel_1;
                        } else if (bigWildData.bigWinPresentOnSymbols?.includes(0) && !bigWildData.bigWinPresentOnSymbols?.includes(1) && !bigWildData.bigWinPresentOnSymbols?.includes(2)) {
                            symAnimToPlay = this._stackSymAnimation_2X2_top_half_reel_1;
                        }
                    } else if (symId === 1 && winOnReel1And2) {
                        if (bigWildData.bigWinPresentOnSymbols?.includes(0) && bigWildData.bigWinPresentOnSymbols?.includes(1)) {
                            return tl;
                        }
                        if (bigWildData.bigWinPresentOnSymbols?.includes(1) && bigWildData.bigWinPresentOnSymbols?.includes(2) && !bigWildData.bigWinPresentOnSymbols?.includes(0)) {
                            symAnimToPlay = this._stackSymAnimation_2X2_full_bottom_reel_1;
                        }
                    } else if (symId === 2 && winOnReel1And2) {
                        if (bigWildData.bigWinPresentOnSymbols?.includes(1) && bigWildData.bigWinPresentOnSymbols?.includes(2)) {
                            return tl;
                        }
                        if (bigWildData.bigWinPresentOnSymbols?.includes(2) && !bigWildData.bigWinPresentOnSymbols?.includes(0) && !bigWildData.bigWinPresentOnSymbols?.includes(1)) {
                            symAnimToPlay = this._stackSymAnimation_2X2_bottom_half_reel_1;
                        }
                    }
                } else if (reelId === 2) {
                    const winOnReel2And3: boolean | undefined = bigWildData.bigWinPresentOnReels?.includes(2) && bigWildData.bigWinPresentOnReels?.includes(3);
                    if (symId === 0 && winOnReel2And3) {
                        if (bigWildData.bigWinPresentOnSymbols?.includes(0) && bigWildData.bigWinPresentOnSymbols?.includes(1) && !bigWildData.bigWinPresentOnSymbols?.includes(2)) {
                            symAnimToPlay = this._stackSymAnimation_2X2_full_top_reel_2;
                        } else if (bigWildData.bigWinPresentOnSymbols?.includes(0) && !bigWildData.bigWinPresentOnSymbols?.includes(1) && !bigWildData.bigWinPresentOnSymbols?.includes(2)) {
                            symAnimToPlay = this._stackSymAnimation_2X2_top_half_reel_2;
                        }
                    } else if (symId === 1 && winOnReel2And3) {
                        if (bigWildData.bigWinPresentOnSymbols?.includes(1) && bigWildData.bigWinPresentOnSymbols?.includes(2) && !bigWildData.bigWinPresentOnSymbols?.includes(0)) {
                            symAnimToPlay = this._stackSymAnimation_2X2_full_bottom_reel_2;
                        }
                    } else if (symId === 2 && winOnReel2And3) {
                        if (bigWildData.bigWinPresentOnSymbols?.includes(2) && !bigWildData.bigWinPresentOnSymbols?.includes(0) && !bigWildData.bigWinPresentOnSymbols?.includes(1)) {
                            symAnimToPlay = this._stackSymAnimation_2X2_bottom_half_reel_2;
                        }
                    } else {
                        if ((symId === 0 && bigWildData.bigWinPresentOnSymbols?.includes(0)) || (symId === 1 && bigWildData.bigWinPresentOnSymbols?.includes(1)) || (symId === 2 && bigWildData.bigWinPresentOnSymbols?.includes(2))) {
                            return tl;
                        }
                    }
                } else {
                    if ((symId === 0 && bigWildData.bigWinPresentOnSymbols?.includes(3) && bigWildData.bigWinPresentOnSymbols?.includes(3)) || (symId === 1 && bigWildData.bigWinPresentOnSymbols?.includes(2) && bigWildData.bigWinPresentOnSymbols?.includes(3)) || (symId === 2 && bigWildData.bigWinPresentOnSymbols?.includes(2) && bigWildData.bigWinPresentOnSymbols?.includes(3))) {
                        return tl;
                    }
                }
            }
        }

        tl.add(symAnimToPlay.show());
        tl.add(symAnimToPlay.getPreWinAnimation({
            frameMaxAlpha: LonerStatics.PRE_WIN_FRAME_ALPHA[reelId],
            duration: LonerStatics.PRE_WIN_ANIM_DURATION,
            tintColor: this.getPreWinTint(symName)
        }));
        tl.add(symAnimToPlay.hide());
        return tl;
    }

    public playWinHighlightAnim(reelId: number, symId: number, symName: string,dur:number=-1): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        let symAnimToPlay: GlowFrame = this._symbolAnimation[reelId][symId];
        if ((reelId === 1 || reelId === 2 || reelId === 3) && Loner.model.bigWildSize >= 2) {
            const bigWildSize: number = Loner.model.bigWildSize;
            const bigWildData = Loner.model.bigWildWinAnimationHighlightData;
            if (bigWildSize === 3) {
                if (reelId === 1) {
                    if (symId === 0) {
                        if (bigWildData.bigWinPresentOnSymbols?.includes(0) && bigWildData.bigWinPresentOnSymbols?.includes(1) && bigWildData.bigWinPresentOnSymbols?.includes(2)) {
                            symAnimToPlay = this._stackSymAnimation_3X3_full;
                        } else if (bigWildData.bigWinPresentOnSymbols?.includes(0) && bigWildData.bigWinPresentOnSymbols?.includes(1) && !bigWildData.bigWinPresentOnSymbols?.includes(2)) {
                            symAnimToPlay = this._stackSymAnimation_3X3_half_top;
                        } else if (bigWildData.bigWinPresentOnSymbols?.includes(0) && !bigWildData.bigWinPresentOnSymbols?.includes(1) && !bigWildData.bigWinPresentOnSymbols?.includes(2)) {
                            symAnimToPlay = this._stackSymAnimation_3X3_top;
                        }
                    } else if (symId === 1) {
                        if (!bigWildData.bigWinPresentOnSymbols?.includes(0) && bigWildData.bigWinPresentOnSymbols?.includes(1) && bigWildData.bigWinPresentOnSymbols?.includes(2)) {
                            symAnimToPlay = this._stackSymAnimation_3X3_half_bottom;
                        } else {
                            if ((bigWildData.bigWinPresentOnSymbols?.includes(0) && bigWildData.bigWinPresentOnSymbols?.includes(1) && bigWildData.bigWinPresentOnSymbols?.includes(2))
                                || (bigWildData.bigWinPresentOnSymbols?.includes(0) && bigWildData.bigWinPresentOnSymbols?.includes(1) && !bigWildData.bigWinPresentOnSymbols?.includes(2))) {
                                return tl;
                            }
                        }
                    } else if (symId === 2) {
                        if (!bigWildData.bigWinPresentOnSymbols?.includes(0) && !bigWildData.bigWinPresentOnSymbols?.includes(1) && bigWildData.bigWinPresentOnSymbols?.includes(2)) {
                            symAnimToPlay = this._stackSymAnimation_3X3_bottom;
                        } else {
                            if ((!bigWildData.bigWinPresentOnSymbols?.includes(0) && bigWildData.bigWinPresentOnSymbols?.includes(1) && bigWildData.bigWinPresentOnSymbols?.includes(2))
                                || (bigWildData.bigWinPresentOnSymbols?.includes(0) && bigWildData.bigWinPresentOnSymbols?.includes(1) && bigWildData.bigWinPresentOnSymbols?.includes(2))) {
                                return tl;
                            }
                        }
                    }
                } else {
                    if (bigWildData.bigWinPresentOnReels?.includes(reelId) && bigWildData.bigWinPresentOnSymbols?.includes(symId)) {
                        return tl;
                    }
                }
            } else if (bigWildSize === 2) {
                if (reelId === 1) {
                    const winOnReel1And2: boolean | undefined = bigWildData.bigWinPresentOnReels?.includes(1) && bigWildData.bigWinPresentOnReels?.includes(2);
                    if (symId === 0 && winOnReel1And2) {
                        if (bigWildData.bigWinPresentOnSymbols?.includes(0) && bigWildData.bigWinPresentOnSymbols?.includes(1) && !bigWildData.bigWinPresentOnSymbols?.includes(2)) {
                            symAnimToPlay = this._stackSymAnimation_2X2_full_top_reel_1;
                        } else if (bigWildData.bigWinPresentOnSymbols?.includes(0) && !bigWildData.bigWinPresentOnSymbols?.includes(1) && !bigWildData.bigWinPresentOnSymbols?.includes(2)) {
                            symAnimToPlay = this._stackSymAnimation_2X2_top_half_reel_1;
                        }
                    } else if (symId === 1 && winOnReel1And2) {
                        if (bigWildData.bigWinPresentOnSymbols?.includes(0) && bigWildData.bigWinPresentOnSymbols?.includes(1)) {
                            return tl;
                        }
                        if (bigWildData.bigWinPresentOnSymbols?.includes(1) && bigWildData.bigWinPresentOnSymbols?.includes(2) && !bigWildData.bigWinPresentOnSymbols?.includes(0)) {
                            symAnimToPlay = this._stackSymAnimation_2X2_full_bottom_reel_1;
                        }
                    } else if (symId === 2 && winOnReel1And2) {
                        if (bigWildData.bigWinPresentOnSymbols?.includes(1) && bigWildData.bigWinPresentOnSymbols?.includes(2)) {
                            return tl;
                        }
                        if (bigWildData.bigWinPresentOnSymbols?.includes(2) && !bigWildData.bigWinPresentOnSymbols?.includes(0) && !bigWildData.bigWinPresentOnSymbols?.includes(1)) {
                            symAnimToPlay = this._stackSymAnimation_2X2_bottom_half_reel_1;
                        }
                    }
                } else if (reelId === 2) {
                    const winOnReel2And3: boolean | undefined = bigWildData.bigWinPresentOnReels?.includes(2) && bigWildData.bigWinPresentOnReels?.includes(3);
                    if (symId === 0 && winOnReel2And3) {
                        if (bigWildData.bigWinPresentOnSymbols?.includes(0) && bigWildData.bigWinPresentOnSymbols?.includes(1) && !bigWildData.bigWinPresentOnSymbols?.includes(2)) {
                            symAnimToPlay = this._stackSymAnimation_2X2_full_top_reel_2;
                        } else if (bigWildData.bigWinPresentOnSymbols?.includes(0) && !bigWildData.bigWinPresentOnSymbols?.includes(1) && !bigWildData.bigWinPresentOnSymbols?.includes(2)) {
                            symAnimToPlay = this._stackSymAnimation_2X2_top_half_reel_2;
                        }
                    } else if (symId === 1 && winOnReel2And3) {
                        if (bigWildData.bigWinPresentOnSymbols?.includes(1) && bigWildData.bigWinPresentOnSymbols?.includes(2) && !bigWildData.bigWinPresentOnSymbols?.includes(0)) {
                            symAnimToPlay = this._stackSymAnimation_2X2_full_bottom_reel_2;
                        }
                    } else if (symId === 2 && winOnReel2And3) {
                        if (bigWildData.bigWinPresentOnSymbols?.includes(2) && !bigWildData.bigWinPresentOnSymbols?.includes(0) && !bigWildData.bigWinPresentOnSymbols?.includes(1)) {
                            symAnimToPlay = this._stackSymAnimation_2X2_bottom_half_reel_2;
                        }
                    } else {
                        if ((symId === 0 && bigWildData.bigWinPresentOnSymbols?.includes(0)) || (symId === 1 && bigWildData.bigWinPresentOnSymbols?.includes(1)) || (symId === 2 && bigWildData.bigWinPresentOnSymbols?.includes(2))) {
                            return tl;
                        }
                    }
                } else {
                    if ((symId === 0 && bigWildData.bigWinPresentOnSymbols?.includes(3) && bigWildData.bigWinPresentOnSymbols?.includes(3)) || (symId === 1 && bigWildData.bigWinPresentOnSymbols?.includes(2) && bigWildData.bigWinPresentOnSymbols?.includes(3)) || (symId === 2 && bigWildData.bigWinPresentOnSymbols?.includes(2) && bigWildData.bigWinPresentOnSymbols?.includes(3))) {
                        return tl;
                    }
                }
            }
        }
        tl.add(symAnimToPlay.show());
        tl.add(symAnimToPlay.getPreWinAnimation({
            frameMaxAlpha: LonerStatics.WIN_HIGHLIGHT_FRAME_ALPHA,
            duration: dur===-1?LonerStatics.WIN_HIGHLIGHT_ANIM_DURATION:dur,
            tintColor: this.getPreWinTint(symName)
        }));
        tl.add(symAnimToPlay.hide());
        return tl;
    }

    private init(): void {
        this.visible = false;
        this.createReelContainers();
    }

    private getPreWinTint(symName: string): number {
        let tintColor: number;
        //color can be changed, different function for
        tintColor = PIXI.utils.string2hex("#FFFFFF");
        return tintColor;
    }

    private createReelContainers(): void {
        const symbolWidth: number = LonerStatics.symbolWidth,
            symbolHeight: number = LonerStatics.symbolHeight;

        for (let reelId: number = 0; reelId < LonerStatics.REEL_NUMBERS; reelId++) {
            const reelContainer: PIXI.Container = new PIXI.Container();
            reelContainer.name = "reel_" + reelId;

            this._symbolAnimation[reelId] = [];

            for (let symId: number = 0; symId < 3; symId++) {
                const symContainer: PIXI.Container = new PIXI.Container(),
                    addInXPos: number = 0,//36
                    addInYPos: number = 124;//86
                symContainer.position.set(addInXPos + LonerStatics.reelPositions[reelId].x, addInYPos + (symbolHeight * symId));
                symContainer.name = "sym_" + symId;

                this._symbolAnimation[reelId][symId] = this.createSymAnimation(1);
                symContainer.addChild(this._symbolAnimation[reelId][symId]);
                reelContainer.addChild(symContainer);
                if (reelId === 1 && symId === 2) {
                    const stackedContainer: PIXI.Container = new PIXI.Container();
                    stackedContainer.name = "3X3_and_2X2_big_wilds";
                    this._stackSymAnimation_3X3_full = this.createSymAnimation(3, 3);
                    this._stackSymAnimation_3X3_full.name = "_stackSymAnimation_3X3_full";
                    this._stackSymAnimation_3X3_full.position.set(symbolWidth, symbolHeight);

                    this._stackSymAnimation_3X3_top = this.createSymAnimation(1, 3);
                    this._stackSymAnimation_3X3_top.name = "_stackSymAnimation_3X3_top";
                    this._stackSymAnimation_3X3_top.position.set(symbolWidth, symbolHeight);

                    this._stackSymAnimation_3X3_half_top = this.createSymAnimation(2, 3);
                    this._stackSymAnimation_3X3_half_top.name = "_stackSymAnimation_3X3_half_top";
                    this._stackSymAnimation_3X3_half_top.position.set(symbolWidth, symbolHeight);

                    this._stackSymAnimation_3X3_bottom = this.createSymAnimation(1, 3);
                    this._stackSymAnimation_3X3_bottom.name = "_stackSymAnimation_3X3_bottom";
                    this._stackSymAnimation_3X3_bottom.position.set(symbolWidth, symbolHeight * 3);

                    this._stackSymAnimation_3X3_half_bottom = this.createSymAnimation(2, 3);
                    this._stackSymAnimation_3X3_half_bottom.name = "_stackSymAnimation_3X3_half_bottom";
                    this._stackSymAnimation_3X3_half_bottom.position.set(symbolWidth, symbolHeight * 2);

                    this._stackSymAnimation_2X2_bottom_half_reel_1 = this.createSymAnimation(1, 2);
                    this._stackSymAnimation_2X2_bottom_half_reel_1.name = "_stackSymAnimation_2X2_bottom_half_reel_1";
                    this._stackSymAnimation_2X2_bottom_half_reel_1.position.set(symbolWidth, symbolHeight * 3);

                    this._stackSymAnimation_2X2_top_half_reel_1 = this.createSymAnimation(1, 2);
                    this._stackSymAnimation_2X2_top_half_reel_1.name = "_stackSymAnimation_2X2_top_half_reel_1";
                    this._stackSymAnimation_2X2_top_half_reel_1.position.set(symbolWidth, symbolHeight);

                    this._stackSymAnimation_2X2_full_bottom_reel_1 = this.createSymAnimation(2, 2);
                    this._stackSymAnimation_2X2_full_bottom_reel_1.name = "_stackSymAnimation_2X2_full_bottom_reel_1";
                    this._stackSymAnimation_2X2_full_bottom_reel_1.position.set(symbolWidth, symbolHeight * 2);

                    this._stackSymAnimation_2X2_full_top_reel_1 = this.createSymAnimation(2, 2);
                    this._stackSymAnimation_2X2_full_top_reel_1.name = "_stackSymAnimation_2X2_full_top_reel_1";
                    this._stackSymAnimation_2X2_full_top_reel_1.position.set(symbolWidth, symbolHeight);


                    stackedContainer.addChild(this._stackSymAnimation_3X3_top, this._stackSymAnimation_3X3_bottom, this._stackSymAnimation_3X3_full, this._stackSymAnimation_3X3_half_top, this._stackSymAnimation_3X3_half_bottom,
                        this._stackSymAnimation_2X2_full_top_reel_1, this._stackSymAnimation_2X2_bottom_half_reel_1, this._stackSymAnimation_2X2_full_bottom_reel_1, this._stackSymAnimation_2X2_top_half_reel_1);
                    reelContainer.addChild(stackedContainer);
                }

                if (reelId === 2 && symId === 2) {
                    const stackedContainer: PIXI.Container = new PIXI.Container();
                    stackedContainer.name = "2X2_big_wilds";

                    this._stackSymAnimation_2X2_bottom_half_reel_2 = this.createSymAnimation(1, 2);
                    this._stackSymAnimation_2X2_bottom_half_reel_2.name = "_stackSymAnimation_2X2_bottom_half_reel_2";
                    this._stackSymAnimation_2X2_bottom_half_reel_2.position.set(symbolWidth * 2, symbolHeight * 3);

                    this._stackSymAnimation_2X2_top_half_reel_2 = this.createSymAnimation(1, 2);
                    this._stackSymAnimation_2X2_top_half_reel_2.name = "_stackSymAnimation_2X2_top_half_reel_2";
                    this._stackSymAnimation_2X2_top_half_reel_2.position.set(symbolWidth * 2, symbolHeight);

                    this._stackSymAnimation_2X2_full_bottom_reel_2 = this.createSymAnimation(2, 2);
                    this._stackSymAnimation_2X2_full_bottom_reel_2.name = "_stackSymAnimation_2X2_full_bottom_reel_2";
                    this._stackSymAnimation_2X2_full_bottom_reel_2.position.set(symbolWidth * 2, symbolHeight * 2);

                    this._stackSymAnimation_2X2_full_top_reel_2 = this.createSymAnimation(2, 2);
                    this._stackSymAnimation_2X2_full_top_reel_2.name = "_stackSymAnimation_2X2_full_top_reel_2";
                    this._stackSymAnimation_2X2_full_top_reel_2.position.set(symbolWidth * 2, symbolHeight);

                    stackedContainer.addChild(this._stackSymAnimation_2X2_bottom_half_reel_2, this._stackSymAnimation_2X2_top_half_reel_2, this._stackSymAnimation_2X2_full_bottom_reel_2, this._stackSymAnimation_2X2_full_top_reel_2);
                    reelContainer.addChild(stackedContainer);
                }
            }
            this.addChild(reelContainer);
        }
    }


    private createSymAnimation(stackSize: number, symWidth: number = 1): GlowFrame {
        const frameSprite: PIXI.NineSlicePlane = new PIXI.NineSlicePlane(Loner.assetLoader.getTextures("glowFrame")[0], 32, 32, 32, 32),
            dotSprites: PIXI.Sprite[] = [
                new PIXI.Sprite(Loner.assetLoader.getTextures("glowDot")[0]),
                new PIXI.Sprite(Loner.assetLoader.getTextures("glowDot")[0]),
                new PIXI.Sprite(Loner.assetLoader.getTextures("glowDot")[0]),
                new PIXI.Sprite(Loner.assetLoader.getTextures("glowDot")[0]),
                new PIXI.Sprite(Loner.assetLoader.getTextures("glowDot")[0]),
                new PIXI.Sprite(Loner.assetLoader.getTextures("glowDot")[0]),
            ],
            sweepSprite: PIXI.Sprite = new PIXI.Sprite(Loner.assetLoader.getTextures("glowSweep")[0]),
            centerLine: PIXI.Sprite = new PIXI.Sprite(Loner.assetLoader.getTextures("glowLine")[0]),
            symbolWidth: number = LonerStatics.symbolWidth,
            symbolHeight: number = LonerStatics.symbolHeight;

        const frame: GlowFrame = new GlowFrame(frameSprite, dotSprites, sweepSprite, centerLine);
        frame.name = "symAnim";
        frame.spread.set(16, 16);
        frame.frameSize.set(symbolWidth * symWidth, symbolHeight * stackSize);
        frame.position.set(0, 0);
        frame.hide();
        return frame;
    }


}